/**
 * Shared Tailwind class constants for inline field visual states.
 * Matches the UX spec from user-story.md (Plan 165).
 */

/** Active editing input — invisible, inherits parent font/color, no chrome */
export const INLINE_INPUT_CLASS =
  "w-full bg-transparent border-0 outline-none p-0 m-0 [font:inherit] text-inherit text-right focus:outline-none focus:ring-0 focus:border-0";

/** Display value wrapper — blends with row, no border/underline (row handles click) */
export const INLINE_DISPLAY_CLASS =
  "inline-flex items-center gap-1.5";

/** Read-only display — no hover effect, shows lock icon on group-hover */
export const INLINE_READONLY_CLASS =
  "inline-flex items-center gap-1.5 cursor-default group";

/** Saved checkmark icon classes */
export const INLINE_SAVED_ICON_CLASS =
  "h-3.5 w-3.5 text-emerald-500 shrink-0";

/** Saving spinner icon classes */
export const INLINE_SAVING_ICON_CLASS =
  "h-3.5 w-3.5 text-muted-foreground motion-safe:animate-spin motion-reduce:animate-none shrink-0";

/** Error icon classes */
export const INLINE_ERROR_ICON_CLASS =
  "h-3.5 w-3.5 text-destructive shrink-0";

/** Error ring applied to display button on save failure */
export const INLINE_ERROR_RING_CLASS =
  "ring-2 ring-destructive/60 rounded-lg";

/** Read-only lock icon — hidden by default, visible on group hover */
export const INLINE_LOCK_ICON_CLASS =
  "h-3.5 w-3.5 text-muted-foreground/40 opacity-0 group-hover:opacity-100 transition-opacity shrink-0";

/** Dirty-commit pulse — brief ring confirms buffer write (no checkmark since nothing persisted) */
export const INLINE_DIRTY_PULSE_CLASS =
  "ring-1 ring-sky-400/40";
